import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import PipExit from '../assets/icons/custom/pip-exit.svg?react';

export function PipExitIcon(props: SvgIconProps) {
  return <SvgIcon component={PipExit} inheritViewBox {...props} />;
}
